<template>
  <div id="quoteOne"></div>
</template>

<script>
export default {
  name: "QuoteOne",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        quote:
          "Using LinkedIn without consistency is like *a ship without a compass*.",
        author: "John Doe",
        author_bio: "Author is a software engineer at Google",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler(newVal) {
        console.log("scale", newVal);
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    isDarkColor(color) {
      let r, g, b;

      // Handle hex color format (#ff0000 or #f00)
      if (color.startsWith("#")) {
        const hex = color.slice(1);
        // Handle 3-digit hex (#f00 -> #ff0000)
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          // Handle 6-digit hex (#ff0000)
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
      } else {
        // Handle RGB format (rgb(255, 0, 0))
        const rgb = color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return false;
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      }

      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128;
    },
    render() {
      const quoteOne = document.getElementById("quoteOne");
      if (!quoteOne) return;
      quoteOne.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const fontSize = exporting ? 70 : 70 * this.scale;
      const logoHeight = exporting ? 50 : 50 * this.scale;
      const authorSize = exporting ? 30 : 30 * this.scale;
      const bioSize = exporting ? 25 : 25 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
          "
        >
          <div style="padding: 10%">
            <img
            src="${logoSrc}"
              height="${logoHeight}px"
              alt=""
            />
          </div>
          <div>
            <div style="margin: 0 10% 5% 10%; font-size: ${fontSize}px; font-weight: 400; border-left: 6px solid #272727; padding-left: 25px">${this.data.quote.replace(
              /\*([^*]+)\*/g,
              '<span class="template-libre">$1</span>',
            )}</div>

            <div style="padding-left: 10%">
              <p style="color: #272727; font-size: ${authorSize}px; margin: 0">
                <b>${this.data.author}</b>
              </p>
              <p style="color: #737373; font-size: ${bioSize}px; margin: 0">${this.data.author_bio}</p>
            </div>
          </div>

          <div style="padding: 10%">
        <div style="display: flex; ">
          <span
            style="
              display: inline-block;
              background: ${this.workspace?.branding?.color?.primary || "#272727"};
              color: ${this.isDarkColor(this.workspace?.branding?.color?.primary || "#272727") ? "#fff" : "#000"};
              font-size: ${authorSize}px;
              font-weight: 500;
              border-radius: 999px;
              padding: 7px 22px;
              letter-spacing: 0.03em;
              font-family: 'Inter', Arial, sans-serif;
              box-shadow: 0 1px 2px rgba(39, 39, 39, 0.03);
            "
          >
            ${this.data.chip}
          </span>
        </div>
          
        </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400..700;1,400..700&display=swap");

.template-libre {
  font-family: "Libre Baskerville", serif;
  font-weight: 500;
  font-style: italic;
}
</style>
